var map = {
	"./covid-hits-home-poster-image-desktop.jpg": "c26c",
	"./covid-hits-home-poster-image.jpg": "4cbe",
	"./covid-hits-home-video-intro-desktop.mp4": "6a2d",
	"./covid-hits-home-video-intro.mp4": "176f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a938";